import React from "react";
import { Link } from "react-router-dom";
import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";

function FooterAuth() {
  return (
    <>
      <footer className="bg-gray-900 tracking-wide px-5 md:px-12 lg:px-32 xl:px-40 2xl:px-60 py-4">
        <div className="flex flex-wrap justify-center gap-x-32 gap-y-5 text-gray-100 mt-8 poppins-regular">
          <span className="py-2 group">
            Ensemble pour l'Afrique
            <div class="bg-pink-600 h-[4px] w-0 group-hover:w-full transition-all duration-500"></div>
          </span>
          <span className="py-2 group">
            Ensemble pour la durabilité
            <div class="bg-pink-600 h-[4px] w-0 group-hover:w-full transition-all duration-500"></div>
          </span>
          <span className="py-2 group text-center">
            Ensemble pour notre maison commune
            <div class="bg-pink-600 h-[4px] w-0 group-hover:w-full transition-all duration-500"></div>
          </span>
        </div>

        <div class="mb-4 flex items-center justify-center space-x-4 mt-8">
          <Link
            href="https://web.facebook.com/profile.php?id=61560310173070"
            target="_blank"
            type="button"
            class="text-pink-600 bg-pink-200 flex items-center rounded-full p-2 leading-normal transition-all duration-300 hover:scale-110 ease-in-out"
            data-twe-ripple-init
          >
            <FaFacebookF size={20} />
          </Link>

          <a
            href="https://www.linkedin.com/ecokaz"
            type="button"
            class="text-pink-600 bg-pink-200 flex items-center rounded-full p-2 leading-normal transition-all duration-300 hover:scale-110 ease-in-out"
            data-twe-ripple-init
          >
            <FaLinkedinIn size={20} />
          </a>

          <a
            href="https://www.instagram.com/ecokaz"
            type="button"
            class="text-pink-600 bg-pink-200 flex items-center rounded-full p-2 leading-normal transition-all duration-300 hover:scale-110 ease-in-out"
            data-twe-ripple-init
          >
            <FaInstagram size={20} />
          </a>
        </div>

        <p className="text-gray-300 text-sm text-center">
          © 2024
          <a
            href="ecokaz.vercel.app"
            target="_blank"
            className="hover:underline mx-1"
          >
            ECOKAZ
          </a>
          All Rights Reserved.
        </p>
      </footer>
    </>
  );
}

export default FooterAuth;
